<template>
  <div class="forgot">
    <div class="logo">
      <img src="https://img.lessonplan.cn/IMG/Public/logo/competition-cover.png" alt="logo">
    </div>

    <div class="forgot-form">
      <template v-if="step === 1">
        <input v-model="username" type="text" placeholder="请输入电话/电子邮箱(phone/email)" class="username">
        <v-select placeholder="选择密保问题(encrypted)" class="v-select" :clearable="false" v-model="security" label="Content"
          :options="securityList"></v-select>
        <input v-model="securityAnswer" type="text" placeholder="密保答案(answer)" class="password" />
        <button class="forgot-btn" @click="startVerify">下一步(next step)</button>
      </template>

      <template v-if="step === 2">
        <input v-model="password" type="password" placeholder="设置密码" class="password" />
        <input v-model="repeatPassword" type="password" placeholder="重复密码" class="password" />
        <button class="forgot-btn" @click="setNewPassword">确 定(make sure)</button>
      </template>
      <div class="go-login"><a @click="goLogin()">返回登录(login)</a></div>
    </div>
  </div>
</template>

<script>
  import vSelect from 'vue-select'
  import 'vue-select/dist/vue-select.css'

  export default {
    name: 'forgot',
    components: {
      vSelect
    },
    props: {
      redirectURI: String,
    },
    data() {
      return {
        userGuid: '',
        securityList: [],
        username: '',
        security: null,
        securityAnswer: '',
        password: '',
        repeatPassword: '',
        step: 1
      }
    },
    async mounted() {
      this.securityList = await this.$api.account.getSecurityList().then(ret => ret.data)
    },
    methods: {
      async startVerify() {
        if (!this.username) {
          return this.$message.warning('请填写您要找回的账号')
        }
        if (!this.security || !this.securityAnswer) {
          return this.$message.warning('请填写密保问题和答案验证')
        }

        const getUserSecurityRet = await this.$api.account.getUserSecurity(this.username)

        if (getUserSecurityRet.status !== 1) {
          return this.$message.warning(getUserSecurityRet.err)
        }
        if (getUserSecurityRet.data.Content !== this.security.Content) {
          return this.$message.warning('验证失败')
        }
        this.userGuid = getUserSecurityRet.data.PK_UserGuid

        const verifyUserSecurityRet = await this.$api.account.verifyUserSecurity({
          username: this.username,
          answer: this.securityAnswer
        })

        if (verifyUserSecurityRet.status !== 1) {
          return this.$message.warning('验证失败')
        }
        this.$message.warning('验证通过，请设置新密码', {
          className: 'success'
        })
        this.step++
      },

      async setNewPassword() {
        if (!this.password || !this.repeatPassword) {
          return this.$message.warning('请填写您的新密码')
        }
        if (this.password !== this.repeatPassword) {
          return this.$message.warning('两次密码输入不一致')
        }

        const setNewPasswordRet = await this.$api.account.setNewPassword({
          PK_UserGuid: this.userGuid,
          Password: this.password
        })
        if (setNewPasswordRet.status === 1) {
          this.$message.warning('新密码设置成功', {
            className: 'success'
          })
          this.$router.push('tsinghua-login')
        }
      },

      goLogin() {
        this.$router.push({ name: 'tsinghua-login', query: { redirectURI: this.redirectURI } })
      },
    }
  }
</script>

<style lang="scss" scoped>
  .forgot {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .logo {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    img {
      width: 270px;
      margin-bottom: 30px;
    }

    h1 {
      font-size: 28px;
      color: #555;
      margin-top: 8px;

      span {
        font-size: 17px;
      }
    }

    p {
      width: 270px;
      text-align: center;
      font-size: 15px;
      color: #888;
      margin-top: 5px;
      margin-bottom: 12px;
    }
  }

  .forgot-form {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;

    .go-login {
      font-size: 14px;
      color: #666666;
      margin-top: 10px;
      text-align: left;
      width: 100%;
    }
  }
</style>